const RatingStatus = {
  1: 'Novice',
  2: 'Developing',
  3: 'Intermediate',
  4: 'Advanced',
  5: 'Elite',
};

export default RatingStatus;
